import React, { useState } from "react";
import IntonationFeedback from "./IntonationFeedback";
import IntonationFeedbackUsers from "./IntonationFeedbackUsers";
import PitchPlotAudio from "./PitchPlotAudio";
import IntensityPlotAudio from "./IntensityPlotAudio";
import CustomAudioPlayer from "./CustomAudioPlayer";
import PitchIntensityAnimation from "./PitchIntensityAnimation";
import MusicNotationView from "./MusicNotationView";
import ColorCodedWordsView from "./ColorCodedWordsView";
import { defaultColormap } from "./colormaps";

const IntonationFeedbackDisplay = ({
  assessment,
  segment,
  view,
  isAdmin,
  audioUrl,
  narratorAudioUrl,
}) => {
  console.log(assessment, "assessment");

  const [selectedColormap, setSelectedColormap] = useState(
    defaultColormap || "speechStable"
  );
  const [currentTime, setCurrentTime] = useState(0);
  const [showLegend, setShowLegend] = useState(true);

  // New behavior:
  // 1) prefer resolved audioUrl passed from parent (SnapsWise)
  // 2) fallback to old path-based backend response for compatibility
  const audio =
    audioUrl ||
    (
      assessment?.intonation?.file
        ? `${process.env.REACT_APP_USER_API_URL}/${assessment.intonation.file}`
        : null
    );

  return (
    <div className="flex flex-col w-full">
      {/* ========================= */}
      {/* USER INTONATION MODULE   */}
      {/* ========================= */}

      {assessment?.intonation?.intensity && assessment?.time_stamped ? (
        <div className="flex flex-col gap-3 w-full">
          {/* VIEW COMPONENTS */}
          {view === "pitch" && (
            <PitchPlotAudio
              currentTime={currentTime}
              intensity={assessment.intonation.intensity}
              time_stamped={assessment.time_stamped}
            />
          )}

          {view === "intensity" && (
            <IntensityPlotAudio
              currentTime={currentTime}
              intensity={assessment.intonation.intensity}
              time_stamped={assessment.time_stamped}
            />
          )}

          {view === "combined" && (
            <PitchIntensityAnimation
              intensity={assessment.intonation.intensity.intensity}
              pitch={assessment.intonation.intensity.pitch}
              segment={assessment.time_stamped}
              broadcastTime={currentTime}
              selectedColormap={selectedColormap}
              onColormapChange={setSelectedColormap}
            />
          )}

          {view === "music" && (
            <MusicNotationView
              pitch={assessment.intonation.intensity.pitch}
              intensity={assessment.intonation.intensity.intensity}
              pitch1stDerivative={
                assessment.intonation.intensity.pitch_1st_derivative
              }
              segment={assessment.time_stamped}
              broadcastTime={currentTime}
            />
          )}

          {view === "colors" && assessment.time_stamped?.words && (
            <ColorCodedWordsView
              words={assessment.time_stamped.words}
              pitch={assessment.intonation.intensity.pitch}
              intensity={assessment.intonation.intensity.intensity}
              segment={assessment.time_stamped}
              broadcastTime={currentTime}
              showLegend={showLegend}
              onToggleLegend={() => setShowLegend(!showLegend)}
            />
          )}

          {/* AUDIO PLAYER */}
          {audio && (
            <CustomAudioPlayer
              audio={audio}
              onTimeUpdate={(t) => setCurrentTime(t)}
            />
          )}
        </div>
      ) : (
        <div className="flex justify-center items-center p-6 bg-gray-50 rounded-xl border border-gray-200">
          <p className="text-gray-500 text-sm">
            Loading user intonation analysis...
          </p>
        </div>
      )}

      {/* ========================= */}
      {/* FEEDBACK SECTION         */}
      {/* ========================= */}

      {/* {assessment?.DTW && (
        <div className="flex flex-col gap-4 p-4 bg-blue-50 rounded-lg border border-blue-200 mt-8">
          {isAdmin ? (
            <IntonationFeedback assessment={assessment} />
          ) : (
            <IntonationFeedbackUsers assessment={assessment} />
          )}
        </div>
      )} */}
    </div>
  );
};

export default IntonationFeedbackDisplay;